import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import Stack from '@mui/material/Stack';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Badge } from 'react-bootstrap';
// import FormLabel from '@mui/material/FormLabel';
// import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';

interface Props {
  id?: string;
  values?: any;
  onChange?: any;
  name?: any;
  disabled?: boolean;
  hidden?: boolean;
  className?: string;
  label?: string;
  logo?: string;
  onClear?: any;
  helperText?: string;
  isMissing?: any;
}

const YesNoSwitch = (props: Props) => {
  const [isActive, setIsActive] = React.useState<Boolean | null>(null);
  React.useEffect(() => {
    if (props.values === 'true' || props.values===true) {
      setIsActive(true)
    }
    else {
      if (props.values === 'false' || props.values===false) {
        setIsActive(false)
      }
      else {
        setIsActive(null);
      }
    }
  }, [props.values]);
  const handleCheck = (e: any) => {
    props.onChange(e);
  };
  const handleClear = () => {
    props.onClear && props.onClear();
  };
  if (props.hidden) return null;
  return (
    <FormControl id={props.id} className={props.className}>
      <div style={{ marginBottom: '2px' }}>
        <div
          className="label-14px" 
          style={{ 
            fontWeight: 600, 
            display: 'flex', 
            alignItems: 'center', 
            gap: 8,
            fontSize: '14px',
            backgroundColor: props.isMissing ? '#FFEBEB' : '',
          }}
        >
          <div
            style={{
              display: 'inline-block',
              backgroundColor: props.isMissing ? '#FFEBEB' : '',
              borderRadius: 6,
              padding: '2px 0px',
            }}
          >
            {props.label}
            {props.logo && <span className={props.logo} style={{ marginLeft: 6 }}></span>}
          </div>
        </div>
      </div>
      {props.helperText && (
        <div style={{ fontSize: 13, color: '#6c757d', marginBottom: 8, marginLeft: 2 }}>
          {props.helperText}
        </div>
      )}
      <RadioGroup row name={props.name} className="mx-2" value={isActive === null ? '' : isActive.toString()}>
        <Stack direction="row" alignItems="center">
          <FormControlLabel
            className={
              isActive === true
                ? 'border rounded ps-1 pe-3 d-inline-block radio-checked-style'
                : 'border rounded ps-1 pe-3 d-inline-block radio-unchecked-style'
            }
            control={<Radio />}
            name={props.name}
            value={'true'}
            id={props.name + 'true'}
            label={<span style={{ fontWeight: 500 }}>Yes</span>}
            disabled={props.disabled}
            onChange={handleCheck}
          />
          <FormControlLabel
            className={
              isActive === false
                ? 'ms-1 border rounded ps-1 pe-3 d-inline-block radio-checked-style'
                : 'ms-1 border rounded ps-1 pe-3 d-inline-block radio-unchecked-style'
            }
            control={<Radio />}
            name={props.name}
            value={'false'}
            id={props.name + 'false'}
            label={<span style={{ fontWeight: 500 }}>No</span>}
            disabled={props.disabled}
            onChange={handleCheck}
          />
          {props.onClear && (
            <span className="me-3">
              <Badge 
                bg="light" 
                text="dark" 
                className="pointer" 
                onClick={props.disabled ? undefined : handleClear}
                style={{
                  backgroundColor: props.disabled ? '#F5F5F5' : '#E3F2FD',
                  color: props.disabled ? '#9E9E9E' : '#1976D2',
                  border: props.disabled ? '1px solid #E0E0E0' : '1px solid #BBDEFB',
                  padding: '8px 16px',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: props.disabled ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s ease',
                  display: 'inline-block',
                  marginLeft: '8px',
                  opacity: props.disabled ? 0.6 : 1,
                }}
                onMouseEnter={props.disabled ? undefined : (e) => {
                  const target = e.target as HTMLElement;
                  target.style.backgroundColor = '#BBDEFB';
                  target.style.color = '#1565C0';
                }}
                onMouseLeave={props.disabled ? undefined : (e) => {
                  const target = e.target as HTMLElement;
                  target.style.backgroundColor = '#E3F2FD';
                  target.style.color = '#1976D2';
                }}
              >
                Clear
              </Badge>
            </span>
          )}
        </Stack>
      </RadioGroup>
      <style>{`
        .radio-unchecked-style {
          margin-left: -8px !important;
          min-width: 120px !important;
          height: 44px !important;
          box-sizing: border-box !important;
          border-radius: 12px !important;
          border: 2px solid #d1d5db !important;
          background: #fff !important;
          color: #222 !important;
          padding: 8px 20px 8px 12px !important;
          display: flex !important;
          align-items: center !important;
          font-weight: 500;
          transition: background 0.2s, color 0.2s, border 0.2s;
        }
        .radio-checked-style {
          min-width: 120px !important;
          height: 44px !important;
          box-sizing: border-box !important;
          border-radius: 12px !important;
          border: 2px solid #4D88F0 !important;
          background: #4D88F0 !important;
          color: #fff !important;
          margin-left: -8px !important;
          padding: 8px 20px 8px 12px !important;
          display: flex !important;
          align-items: center !important;
          font-weight: 500;
          transition: background 0.2s, color 0.2s, border 0.2s;
        }
        .radio-checked-style .MuiFormControlLabel-label,
        .radio-unchecked-style .MuiFormControlLabel-label {
          margin-left: 8px !important;
        }
        .radio-checked-style .MuiRadio-root {
          color: #fff !important;
        }
        .radio-unchecked-style .MuiRadio-root {
          color: #4D88F0 !important;
        }
        .radio-checked-style .Mui-checked {
          color: #fff !important;
        }
        .form-check-input:checked {
          background-color: #4D88F0 !important;
          border-color: #4D88F0 !important;
        }
      `}</style>
    </FormControl>
  );
};

export default YesNoSwitch;
